<!--
 * =====================================================================
 * 작 업 명  : 회원계정정보 수정
 * 파 일 명  : EditAccount.vue
 * 변경이력
 * 2022-01-29 / 정태화 / 최초작성
 * 2022-03-02 / 경다찬 / 디자인 변경 및 기능추가
 * =====================================================================
 -->
<template>
	<h3 class="title mt-5 text-center">
		<button
			class="btn rounded-circle border-0 bg-whites"
			@click="cancelClick()"
		>
			<svg
				xmlns="http://www.w3.org/2000/svg"
				width="32"
				height="42"
				fill="currentColor"
				class="bi bi-arrow-left-short"
				viewBox="0 0 16 16"
			>
				<path
					fill-rule="evenodd"
					d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"
				></path>
			</svg>
		</button>
		Manage account info
	</h3>
	<div class="border-bottom mb-4"></div>
	<h6 class="title mb-4 text-center">
		Some info may be visible to other people using Dot services.
	</h6>
	<div class="row mb-4">
		<div class="col-sm-4"></div>
		<div class="col-sm-4 list-group-item rounded-3">
			<div class="text mt-3 mb-4"><h5>You can change your name</h5></div>
			<div class="row">
				<!-- FULL NAME -->
				<div class="col mt-3 mb-1">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
                            id="first-name"
							v-model="this.user.FIRST_NAME"
						/>
						<label for="first-name">First name</label>
					</div>
				</div>

				<div class="col mt-3 mb-1">
					<div class="form-floating">
						<input
							type="text"
							class="form-control"
                            id="last-name"
							v-model="this.user.LAST_NAME"
						/>
						<label for="last-name">Last name</label>
					</div>
				</div>
			</div>
			<div class="row">
				<div class="col-sm-6 mb-4">
					<div ref="msg" class="check" role="alert">&nbsp;</div>
				</div>
			</div>
			<div class="row">
				<div class="col mb-2 d-flex justify-content-end">
					<button type="button" class="btn btn-dark" @click="editName()">
						Save
					</button>
				</div>
			</div>
		</div>
		<div class="col-sm-4"></div>
	</div>
</template>
<script>
import { router } from "@/router/index.js";
import { $global, $axios, $error } from "@/dot-ui/index.js";
import { Join } from "@/js/user/Join.js";

export default {
	data() {
		return {
			user: {
				USER_NO: localStorage.getItem("_USER_NO_"),
				FIRST_NAME: "",
				LAST_NAME: "",
				EMAIL: "",
			},
			fromParams: "",
			searched: false,
		};
	},
	created()
    {
		this.fromParams = $global.getUrlParams();
	},
	mounted()
    {
		this.search();
	},
	methods:
    {
		async search()
        {
			let fromSiteNo = this.fromParams.s;
			let fromCompNo = this.fromParams.c;
			let url = "/user-app/v1/sites/" + fromSiteNo + "-" + fromCompNo + "/users/" + this.user.USER_NO;
			let response = await $axios.get(url, {}, true);

			if (response.status == 200) {
				let json = response.data;
				this.user = json;

			} else {
				$error.showMessage(response, this);
			}
		},
		async editName()
        {
            this.$refs.msg.innerHTML = "";

			let fromSiteNo = this.fromParams.s;
			let fromCompNo = this.fromParams.c;
			let url = "/user-app/v1/sites/" + fromSiteNo + "-" + fromCompNo + "/users/" + this.user.USER_NO + "/editUser";
			let param = this.user;
			let response = await $axios.put(url, param);

			if (response.status == 200) {
				this.searched = true;
                this.$refs.msg.innerHTML = "This has been changed.";
                Join.setColorClass(this.$refs.msg, "blue");

			} else {
				$error.showMessage(response, this);
			}
		},
		cancelClick()
        {
			router.push({
                path: "/basic",
                query: {
                    cb: this.fromParams.cb,
                    s: this.fromParams.s,
                    c: this.fromParams.c,
                },
            });
		},
	},
};
</script>
<style>
.red {
  color: red;
}
.blue {
  color: blue;
}
.black {
  color: black;
}
</style>
